import { render, staticRenderFns } from "./Interfaces-Add.vue?vue&type=template&id=726270d8&"
import script from "./Interfaces-Add.vue?vue&type=script&lang=js&"
export * from "./Interfaces-Add.vue?vue&type=script&lang=js&"
import style0 from "./Interfaces-Add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports